import { useSelector } from 'react-redux'
import { dialogsSelector } from '../../flow/selectors/dialogsSelector'

export function useDialogs() {
  return useSelector(dialogsSelector)
}
